import React from "react"

let L
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css"

class Map extends React.Component {
	constructor(props) {
		super(props)

		let center = [42, 15]
		if (props.point && props.point.length === 2)
			// point
			center = props.point
		else if (props.point && props.point.length === 4)
			// polygon
			center = this.getCenter(props.point)

		this.state = {
			map: undefined,
			id: props.id || "map",
			title: props.title || "Location",
			width: props.width || "",
			height: props.height || (props.minHeight ? "auto" : "300px"),
			minHeight: props.minHeight || "300px",
			center: center,
			point: props.point,
			points: props.points || [],
			zoom: props.zoom || 3,
			description: props.description,
			controls: props.controls !== "false",
			popup: props.popup !== "false",
			cluster: props.cluster === true,
			backgroundColor: props.backgroundColor || "#000",
			clusterClick: props.clusterClick || function() {},
			click: props.click || function() {},
			vectorLayer: props.vectorLayer || undefined
		}
	}

	// expects [x1,y1,x2,y2]
	// returns [dx,dy]
	getCenter(polygon) {
		return [(polygon[0] + polygon[2]) / 2, (polygon[1] + polygon[3]) / 2]
	}

	addMarker(point, title, description, url, autoOpen) {
		const coordinates = point.length === 4 ? this.getCenter(point) : point
		// leaflet expects (y, x) pairs instead of (x, y) pairs, hence coordinates.reverse()
		const marker = L.marker(coordinates.reverse()).addTo(this.markerLayer)
		const finalDescription = description
			? description
			: `N ${coordinates[0].toFixed(2)}, E ${coordinates[1].toFixed(2)}`
		if (url) {
			marker.bindPopup(`
					<h2><a href="${url}">${title}</a></h2>
					${finalDescription}
				`)
		} else
			marker.bindPopup(`
					<h2>${title}</h2>
					${finalDescription}
				`)
		if (autoOpen && this.state.popup) marker.openPopup()
		return marker
	}

	componentDidMount() {
		L = require("leaflet/dist/leaflet.js")
		// workaround, see: https://github.com/PaulLeCam/react-leaflet/issues/255
		if (L) {
			L.Icon.Default.imagePath = "."
			delete L.Icon.Default.prototype._getIconUrl
			L.Icon.Default.mergeOptions({
				iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
				iconUrl: require("leaflet/dist/images/marker-icon.png"),
				shadowUrl: require("leaflet/dist/images/marker-shadow.png")
			})
		}
		// workaround end
		require("leaflet.markercluster/dist/leaflet.markercluster.js")

		this.markerLayer = L.markerClusterGroup({
			zoomToBoundsOnClick: false
		})
		this.markerLayer.on("clusterclick", this.state.clusterClick)

		if (!this.state.map) {
			const map = new L.Map(this.state.id, {
				center: this.state.center,
				zoom: this.state.zoom,
				maxZoom: 16,
				minZoom: 2,
				zoomControl: this.state.controls,
				worldCopyJump: true
			})
			/*const tileLayer = L.tileLayer(
				"https://api.tiles.mapbox.com/v4/mapbox.streets-satellite/{z}/{x}/{y}.png?access_token={accessToken}",
				{
					accessToken:
						"pk.eyJ1IjoieXllbmVyIiwiYSI6ImNqY3FnNGQ2dzFwMHEzM3BoZXljenA5ZW4ifQ.rJ20wZ9dYhJw9dOx0pGjLw",
					attribution:
						'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
					maxZoom: 16,
					minZoom: 2
				}
			)*/
			const tileLayer = L.tileLayer(
				"http://{s}.tile.osm.org/{z}/{x}/{y}.png",
				{
					attribution:
						'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
					maxZoom: 16,
					minZoom: 2
				}
			)
			map.addLayer(tileLayer)
			map.addLayer(this.markerLayer)
			map.on("click", this.state.click)
			map.on("moveend", ev => this.props.onMove && this.props.onMove(ev))

			if (this.state.point)
				this.addMarker(
					this.state.point,
					this.state.title,
					this.state.description,
					this.state.url,
					true
				)
			this.state.points.forEach(point =>
				this.addMarker(
					point.coordinates,
					point.title,
					point.description,
					point.url
				)
			)

			if (this.state.vectorLayer) {
				const wmsLayer = L.tileLayer
					.wms("http://sfb806srv.uni-koeln.de/wmsproxy.php?", {
						layers: this.state.vectorLayer,
						transparent: true,
						format: "image/png"
					})
					.addTo(map)
			}

			this.setState({
				map: map
			})
		}
	}

	componentWillUnmount() {
		if (this.state.map) {
			this.state.map.off()
			this.state.map.remove()
		}
	}

	render() {
		return (
			<div
				id={this.state.id}
				className={this.props.className}
				style={{
					width: this.state.width,
					height: this.state.height,
					minHeight: this.state.minHeight,
					backgroundColor: this.state.backgroundColor
				}}
			/>
		)
	}
}

export default Map



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/components/Map/index.js